import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=71b4c830&scoped=true&lang=pug&"
import script from "./announcement.ts?vue&type=script&lang=ts&"
export * from "./announcement.ts?vue&type=script&lang=ts&"
import style0 from "./announcement.vue?vue&type=style&index=0&id=71b4c830&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4c830",
  null
  
)

export default component.exports